import { dmsConfig } from './dms';
import { platformConfig } from './platform';
import type { AppConfig } from './types';

const appConfigs: Record<string, AppConfig> = {
  dms: dmsConfig,
  platform: platformConfig,
};

export function getAppConfig(appId: string): AppConfig {
  const config = appConfigs[appId];
  if (!config) {
    throw new Error(`Unknown app ID: "${appId}". Expected "dms" or "platform".`);
  }
  return config;
}

export type { AppConfig } from './types';
